
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { useGym } from '@/contexts/gym-context';
import { CheckInTable } from '@/components/check-in/check-in-table';
import { Attendance } from '../dashboard/attendance';

export function ReceptionView() {
  const { t } = useTranslation();
  const [refreshKey, setRefreshKey] = useState(0);
  const { selectedGym } = useGym();

  const handleCheckInSuccess = () => {
    // Refresh the table when a check-in/out is successful
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <h1 className="text-3xl font-bold">Check-in</h1>
      </div>

      {!selectedGym ? (
        <Card>
          <CardContent className="pt-6">
            <div className="text-center">
              <p className="text-lg font-medium">{t('common.noActiveGym')}</p>
              <p className="text-sm text-muted-foreground mt-1">
                {t('dashboard.selectGymPrompt')}
              </p>
            </div>
          </CardContent>
        </Card>
      ) : (
        <div className="space-y-6">
          <Attendance selectedGym={selectedGym} />
          <div className="bg-card rounded-lg border shadow-sm">
            <div className="p-6">
              <h2 className="text-2xl font-bold mb-4">
                {t('checkIn.recentActivity')}
              </h2>
              <CheckInTable key={refreshKey} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
